import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LoginComponent } from './login/login.component';
import { UserNotFoundComponent } from './user-not-found/user-not-found.component';

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [ LoginComponent, UserNotFoundComponent ],
  exports: [ LoginComponent, UserNotFoundComponent ]
})
export class LoginModule { }
